var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangleinsetbottomtrailingfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46777 16.8633H18.5234C20.4219 16.8633 21.4062 15.8877 21.4062 14.0156V3.31055C21.4062 1.43848 20.4219 0.462891 18.5234 0.462891H3.46777C1.56934 0.462891 0.584961 1.42969 0.584961 3.31055V14.0156C0.584961 15.8877 1.56934 16.8633 3.46777 16.8633ZM3.57324 15.1406C2.75586 15.1406 2.30762 14.7188 2.30762 13.8662V3.45996C2.30762 2.60742 2.75586 2.17676 3.57324 2.17676H18.418C19.2266 2.17676 19.6836 2.60742 19.6836 3.45996V13.8662C19.6836 14.7188 19.2266 15.1406 18.418 15.1406H3.57324ZM11.6855 13.8574H17.7061C18.1982 13.8574 18.4004 13.6553 18.4004 13.1543V9.36621C18.4004 8.86523 18.1982 8.6543 17.7061 8.6543H11.6855C11.1934 8.6543 10.9912 8.86523 10.9912 9.36621V13.1543C10.9912 13.6553 11.1934 13.8574 11.6855 13.8574Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleinsetbottomtrailingfilled);
export default __webpack_public_path__ + "static/media/rectangle.inset.bottomtrailing.filled.f1fe1a81.svg";
export { ForwardRef as ReactComponent };